import React from "react";
import styled from "styled-components";

import { Button } from "js/Components/Button";
import { themeColors } from "js/react/sharedStyles";
import { defaultTitle, smallText } from "js/textStyles";

interface UpgradeSectionProps {
    className?: string;
    title?: string;
    body?: string;
    buttonText: string;
    buttonIcon: string | React.ReactNode;
    buttonOnClick: () => void;
}

const StyledUpgradeSection = styled.div.attrs({ "data-test-id": "upgrade-section" })`
    margin-top: auto;
    display: flex;
    padding: 10px;
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
    align-self: stretch;
    border-radius: 3px;
    background: #F7FAFC;
`;

const UpgradeTextHeader = styled.div.attrs({ "data-test-id": "upgrade-section-header" })`
    ${defaultTitle}
    color: #333;
    letter-spacing: 0;
`;

const UpgradeTextBody = styled.div.attrs({ "data-test-id": "upgrade-section-body" })`
    ${smallText}
    color: ${themeColors.mediumGray};
    margin-bottom: 10px;
`;

const UpgradeSection = ({ className, title, body, buttonText, buttonIcon, buttonOnClick }: UpgradeSectionProps) => {
    return (<StyledUpgradeSection className={className}>
        {title && (
            <UpgradeTextHeader>
                {title}
            </UpgradeTextHeader>
        )}
        {body && (
            <UpgradeTextBody>
                {body}
            </UpgradeTextBody>
        )}
        <Button
            upgrade
            width="100%"
            onClick={buttonOnClick}
        >
            {typeof buttonIcon === "string" ? <img src={buttonIcon} /> : buttonIcon}
            {buttonText}
        </Button>
    </StyledUpgradeSection>);
};

export default UpgradeSection;
